import React from 'react';
import { useAdminAuth } from '../Context/adminAuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const AdminPrivateRoute = () => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a spinner
  }

  return admin ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default AdminPrivateRoute;